import { X, Calendar, Hash, Tag } from 'lucide-react';
import { formatDateTime } from 'utils/dateFormatter';

const ViewSubCategoryModal = (props) => {
  const { isViewModalOpen, setIsViewModalOpen, category } = props;
  if (!isViewModalOpen || !category) return null;

  // console.log("view sub-category modal data:::::::::::::::", category);

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto custom-scrollbar'>
        {/* Header */}
        <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>
          <h2 className='text-lg font-semibold'>Sub-Category Details</h2>
          <button
            onClick={() => setIsViewModalOpen(false)}
            className='p-1 hover:bg-muted rounded-md transition-colors'
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className='p-6 space-y-6'>
          {/* Media Section */}
         {category.image && (
  <div className='space-y-2'>
    <label className='text-xs font-medium text-muted-foreground uppercase'>
      Image
    </label>
    <img
      src={category.image}
      alt='Sub-Category Image'
      className='w-full h-32 object-cover rounded-lg border border-border'
    />
  </div>
)}

          {/* Parent Category */}
          {category.parentCategory && (
            <div className='bg-blue-500/10 border border-blue-500/20 rounded-lg p-4'>
              <label className='text-xs font-medium text-muted-foreground uppercase block mb-2'>
                Parent Category
              </label>
              <div className='flex items-center space-x-3'>
                {category.parentCategory.icon && (
                  <img
                    src={category.parentCategory.icon}
                    alt={category.parentCategory.name?.english}
                    className='w-12 h-12 rounded-lg object-cover border border-border'
                  />
                )}
                <div>
                  <div className='text-sm font-semibold text-blue-600 dark:text-blue-400'>
                    {category.parentCategory.name?.english}
                  </div>
                  <div className='text-xs text-muted-foreground'>
                    {category.parentCategory.slug}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Basic Info */}
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Tag size={14} />
                <span>Name (English)</span>
              </label>
              <p className='text-sm font-medium'>
                {category.name?.english || 'N/A'}
              </p>
            </div>

            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Tag size={14} />
                <span>Name (Hindi)</span>
              </label>
              <p className='text-sm font-medium'>
                {category.name?.hindi || 'N/A'}
              </p>
            </div>

            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Tag size={14} />
                <span>Name (Marwari)</span>
              </label>
              <p className='text-sm font-medium'>
                {category.name?.marwari || 'N/A'}
              </p>
            </div>

            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Hash size={14} />
                <span>Slug</span>
              </label>
              <p className='text-sm text-muted-foreground'>
                {category.slug}
              </p>
            </div>
          </div>

          {/* Description */}
          {category.description && (
            <div className='space-y-3'>
              <label className='text-xs font-medium text-muted-foreground uppercase'>
                Description
              </label>
              <div className='space-y-2 bg-muted rounded-lg p-4'>
                {category.description.english && (
                  <div>
                    <p className='text-xs font-medium text-muted-foreground mb-1'>
                      English:
                    </p>
                    <p className='text-sm'>{category.description.english}</p>
                  </div>
                )}
                {category.description.hindi && (
                  <div>
                    <p className='text-xs font-medium text-muted-foreground mb-1'>
                      Hindi:
                    </p>
                    <p className='text-sm'>{category.description.hindi}</p>
                  </div>
                )}
                {category.description.marwari && (
                  <div>
                    <p className='text-xs font-medium text-muted-foreground mb-1'>
                      Marwari:
                    </p>
                    <p className='text-sm'>{category.description.marwari}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Display Settings */}
          <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase'>
                Display Order
              </label>
              <p className='text-sm'>
                <span className='px-2 py-1 bg-secondary text-secondary-foreground rounded-md text-xs font-medium'>
                  {category.displayOrder}
                </span>
              </p>
            </div>

            {/* {category.color && (
              <div className='space-y-1'>
                <label className='text-xs font-medium text-muted-foreground uppercase'>Color</label>
                <div className='flex items-center space-x-2'>
                  <div className='w-6 h-6 rounded border border-border' style={{ backgroundColor: category.color }} />
                  <p className='text-xs'>{category.color}</p>
                </div>
              </div>
            )} */}
          </div>

          {/* Status Badges */}
          {/* <div className='space-y-2'>
            <label className='text-xs font-medium text-muted-foreground uppercase'>
              Status & Flags
            </label>
            <div className='flex flex-wrap gap-2'>
              <span
                className={`px-3 py-1 text-xs font-medium rounded-full ${
                  category.isActive
                    ? 'bg-green-500/10 text-green-600 dark:text-green-400'
                    : 'bg-gray-500/10 text-gray-600 dark:text-gray-400'
                }`}
              >
                {category.isActive ? 'Active' : 'Inactive'}
              </span>
              <span
                className={`px-3 py-1 text-xs font-medium rounded-full ${
                  category.isPopular
                    ? 'bg-orange-500/10 text-orange-600 dark:text-orange-400'
                    : 'bg-gray-500/10 text-gray-600 dark:text-gray-400'
                }`}
              >
                {category.isPopular ? 'Popular' : 'Regular'}
              </span>
              <span
                className={`px-3 py-1 text-xs font-medium rounded-full ${
                  category.isFeatured
                    ? 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400'
                    : 'bg-gray-500/10 text-gray-600 dark:text-gray-400'
                }`}
              >
                {category.isFeatured ? 'Featured' : 'Normal'}
              </span>
            </div>
          </div> */}

          {/* SEO Section */}
          {/* {category.seo && (
            <div className='space-y-3 bg-muted rounded-lg p-4'>
              <label className='text-xs font-medium text-muted-foreground uppercase'>
                SEO Information
              </label>
              <div className='space-y-2'>
                {category.seo.metaTitle && (
                  <div>
                    <p className='text-xs font-medium text-muted-foreground mb-1'>
                      Meta Title:
                    </p>
                    <p className='text-sm'>{category.seo.metaTitle}</p>
                  </div>
                )}
                {category.seo.metaDescription && (
                  <div>
                    <p className='text-xs font-medium text-muted-foreground mb-1'>
                      Meta Description:
                    </p>
                    <p className='text-sm'>{category.seo.metaDescription}</p>
                  </div>
                )}
                {category.seo.keywords && category.seo.keywords.length > 0 && (
                  <div>
                    <p className='text-xs font-medium text-muted-foreground mb-1'>
                      Keywords:
                    </p>
                    <div className='flex flex-wrap gap-1'>
                      {category.seo.keywords.map((keyword, index) => (
                        <span
                          key={index}
                          className='px-2 py-0.5 bg-primary/10 text-primary text-xs rounded'
                        >
                          {keyword}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )} */}

          {/* Timestamps */}
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-border'>
            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Calendar size={14} />
                <span>Created At</span>
              </label>
              <p className='text-sm'>{formatDateTime(category.createdAt)}</p>
            </div>

            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Calendar size={14} />
                <span>Updated At</span>
              </label>
              <p className='text-sm'>{formatDateTime(category.updatedAt)}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className='flex justify-end px-6 py-4 border-t border-border'>
          <button
            onClick={() => setIsViewModalOpen(false)}
            className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewSubCategoryModal;
